// extracted by mini-css-extract-plugin
export default {"selectedDate":"mini-calendar_selectedDate__uLqqc","nonSelectedDate":"mini-calendar_nonSelectedDate__k9L1S"};